import {
  CRM_OPPORTUNITY_DETAIL_FIELD_KEY,
  CRM_STAGE_DETAIL_FIELD_KEY
} from "./chunk-Q42BW4RB.js";
import {
  BaseItemModel_default
} from "./chunk-UPAELC5I.js";
import {
  BaseModel_default
} from "./chunk-ITJMNR7M.js";

// src/Crm/CrmOpportunity/CrmOpportunityModel.ts
var OpportunityModel = class extends BaseModel_default {
  constructor(entities) {
    super(entities);
    if (entities) {
      this.items = entities._embedded.item.map((element) => {
        return new OpportunityItemModel(element);
      });
    }
  }
};
var OpportunityItemModel = class extends BaseItemModel_default {
  constructor(entity) {
    super(entity);
    this.id = null;
    this.crm_opportunity_name = null;
    this.crm_opportunity_company = null;
    this.crm_opportunity_contact = [];
    this.crm_opportunity_source = null;
    this.crm_opportunity_budget_amount = null;
    this.crm_opportunity_estimated_value = null;
    this.crm_opportunity_ending_date = null;
    this.crm_opportunity_stage = null;
    this.crm_opportunity_close_probability = null;
    this.crm_opportunity_next_step = null;
    this.crm_opportunity_description = null;
    this.created_by = null;
    this.created_time = null;
    this.status = null;
    this.modified_by = null;
    this.modified_time = null;
    this.featured = null;
    this.toObject = () => {
      return {};
    };
    this.toJSON = () => {
      return {
        ...this.baseToJSON(),
        [CRM_OPPORTUNITY_DETAIL_FIELD_KEY.ID]: this.id,
        [CRM_OPPORTUNITY_DETAIL_FIELD_KEY.NAME]: this.crm_opportunity_name,
        [CRM_OPPORTUNITY_DETAIL_FIELD_KEY.COMPANY]: this.crm_opportunity_company,
        [CRM_OPPORTUNITY_DETAIL_FIELD_KEY.CONTACT]: this.crm_opportunity_contact,
        [CRM_OPPORTUNITY_DETAIL_FIELD_KEY.SOURCE]: this.crm_opportunity_source,
        [CRM_OPPORTUNITY_DETAIL_FIELD_KEY.BUDGET_AMOUNT]: this.crm_opportunity_budget_amount,
        [CRM_OPPORTUNITY_DETAIL_FIELD_KEY.ESTIMATED_VALUE]: this.crm_opportunity_estimated_value,
        [CRM_OPPORTUNITY_DETAIL_FIELD_KEY.ENDING_DATE]: this.crm_opportunity_ending_date,
        [CRM_OPPORTUNITY_DETAIL_FIELD_KEY.STAGE]: this.crm_opportunity_stage,
        [CRM_OPPORTUNITY_DETAIL_FIELD_KEY.CLOSE_PROBABILITY]: this.crm_opportunity_close_probability,
        [CRM_OPPORTUNITY_DETAIL_FIELD_KEY.NEXT_STEP]: this.crm_opportunity_next_step,
        [CRM_OPPORTUNITY_DETAIL_FIELD_KEY.DESCRIPTION]: this.crm_opportunity_close_probability,
        [CRM_OPPORTUNITY_DETAIL_FIELD_KEY.CREATED_TIME]: this.created_time,
        [CRM_OPPORTUNITY_DETAIL_FIELD_KEY.CREATED_BY]: this.created_by,
        [CRM_OPPORTUNITY_DETAIL_FIELD_KEY.STATUS]: this.status,
        [CRM_OPPORTUNITY_DETAIL_FIELD_KEY.MODIFIED_BY]: this.modified_by,
        [CRM_OPPORTUNITY_DETAIL_FIELD_KEY.MODIFIED_TIME]: this.modified_time,
        [CRM_OPPORTUNITY_DETAIL_FIELD_KEY.FEATURED]: this.featured
      };
    };
    if (entity) {
      this.id = entity[CRM_OPPORTUNITY_DETAIL_FIELD_KEY.ID] ?? "";
      this.crm_opportunity_name = entity[CRM_OPPORTUNITY_DETAIL_FIELD_KEY.NAME] ?? "";
      this.crm_opportunity_company = entity[CRM_OPPORTUNITY_DETAIL_FIELD_KEY.COMPANY] ?? "";
      this.crm_opportunity_contact = entity[CRM_OPPORTUNITY_DETAIL_FIELD_KEY.CONTACT] ?? [];
      this.crm_opportunity_source = entity[CRM_OPPORTUNITY_DETAIL_FIELD_KEY.SOURCE] ?? "";
      this.crm_opportunity_budget_amount = entity[CRM_OPPORTUNITY_DETAIL_FIELD_KEY.BUDGET_AMOUNT] ?? "";
      this.crm_opportunity_estimated_value = entity[CRM_OPPORTUNITY_DETAIL_FIELD_KEY.ESTIMATED_VALUE] ?? "";
      this.crm_opportunity_ending_date = entity[CRM_OPPORTUNITY_DETAIL_FIELD_KEY.ENDING_DATE] ?? "";
      this.crm_opportunity_stage = entity[CRM_OPPORTUNITY_DETAIL_FIELD_KEY.STAGE] ?? "";
      this.crm_opportunity_close_probability = entity[CRM_OPPORTUNITY_DETAIL_FIELD_KEY.CLOSE_PROBABILITY] ?? "";
      this.crm_opportunity_next_step = entity[CRM_OPPORTUNITY_DETAIL_FIELD_KEY.NEXT_STEP] ?? "";
      this.crm_opportunity_description = entity[CRM_OPPORTUNITY_DETAIL_FIELD_KEY.DESCRIPTION] ?? "";
      this.created_time = entity[CRM_OPPORTUNITY_DETAIL_FIELD_KEY.CREATED_TIME] ?? "";
      this.created_by = entity[CRM_OPPORTUNITY_DETAIL_FIELD_KEY.CREATED_BY] ?? "";
      this.status = entity[CRM_OPPORTUNITY_DETAIL_FIELD_KEY.STATUS] ?? "";
      this.modified_by = entity[CRM_OPPORTUNITY_DETAIL_FIELD_KEY.MODIFIED_BY] ?? "";
      this.modified_time = entity[CRM_OPPORTUNITY_DETAIL_FIELD_KEY.MODIFIED_TIME] ?? "";
      this.featured = entity[CRM_OPPORTUNITY_DETAIL_FIELD_KEY.FEATURED] ?? "";
    }
  }
};
OpportunityItemModel.__transformItemToApiOfCreation = (data) => {
  let formData = new FormData();
  const excluded = [
    CRM_OPPORTUNITY_DETAIL_FIELD_KEY.ID,
    CRM_OPPORTUNITY_DETAIL_FIELD_KEY.CONTACT,
    CRM_OPPORTUNITY_DETAIL_FIELD_KEY.STAGE,
    CRM_OPPORTUNITY_DETAIL_FIELD_KEY.COMPANY
  ];
  Object.keys(CRM_OPPORTUNITY_DETAIL_FIELD_KEY).forEach((index) => {
    if (!excluded.includes(CRM_OPPORTUNITY_DETAIL_FIELD_KEY[index]) && data[CRM_OPPORTUNITY_DETAIL_FIELD_KEY[index]]) {
      formData.append(
        CRM_OPPORTUNITY_DETAIL_FIELD_KEY[index],
        data[CRM_OPPORTUNITY_DETAIL_FIELD_KEY[index]]
      );
    }
  });
  if (data[CRM_OPPORTUNITY_DETAIL_FIELD_KEY.CONTACT] && data[CRM_OPPORTUNITY_DETAIL_FIELD_KEY.CONTACT].length) {
    data[CRM_OPPORTUNITY_DETAIL_FIELD_KEY.CONTACT].map((item) => {
      return formData.append(CRM_OPPORTUNITY_DETAIL_FIELD_KEY.CONTACT + "[]", item.id);
    });
  }
  if (data[CRM_OPPORTUNITY_DETAIL_FIELD_KEY.STAGE]) {
    formData.append(
      CRM_OPPORTUNITY_DETAIL_FIELD_KEY.STAGE,
      data[CRM_OPPORTUNITY_DETAIL_FIELD_KEY.STAGE]?.id
    );
  }
  if (data[CRM_OPPORTUNITY_DETAIL_FIELD_KEY.COMPANY]) {
    formData.append(
      CRM_OPPORTUNITY_DETAIL_FIELD_KEY.COMPANY,
      data[CRM_OPPORTUNITY_DETAIL_FIELD_KEY.COMPANY]?.id
    );
  }
  return formData;
};
OpportunityItemModel.__transformItemToApiOfUpdation = (data) => {
  let formData = {};
  const excluded = [
    CRM_OPPORTUNITY_DETAIL_FIELD_KEY.CONTACT,
    CRM_OPPORTUNITY_DETAIL_FIELD_KEY.STAGE,
    CRM_OPPORTUNITY_DETAIL_FIELD_KEY.COMPANY
  ];
  Object.keys(CRM_OPPORTUNITY_DETAIL_FIELD_KEY).forEach((index) => {
    if (!excluded.includes(CRM_OPPORTUNITY_DETAIL_FIELD_KEY[index]) && data[CRM_OPPORTUNITY_DETAIL_FIELD_KEY[index]]) {
      formData[CRM_OPPORTUNITY_DETAIL_FIELD_KEY[index]] = data[CRM_OPPORTUNITY_DETAIL_FIELD_KEY[index]];
    }
  });
  if (data[CRM_OPPORTUNITY_DETAIL_FIELD_KEY.CONTACT]?.length) {
    formData[CRM_OPPORTUNITY_DETAIL_FIELD_KEY.CONTACT] = data[CRM_OPPORTUNITY_DETAIL_FIELD_KEY.CONTACT].map((item) => {
      return item.id;
    });
  } else {
    formData[CRM_OPPORTUNITY_DETAIL_FIELD_KEY.CONTACT + "[]"] = "";
  }
  if (data[CRM_OPPORTUNITY_DETAIL_FIELD_KEY.STAGE]) {
    formData[CRM_OPPORTUNITY_DETAIL_FIELD_KEY.STAGE] = data[CRM_OPPORTUNITY_DETAIL_FIELD_KEY.STAGE]?.id;
  }
  if (data[CRM_OPPORTUNITY_DETAIL_FIELD_KEY.COMPANY]) {
    formData[CRM_OPPORTUNITY_DETAIL_FIELD_KEY.COMPANY] = data[CRM_OPPORTUNITY_DETAIL_FIELD_KEY.COMPANY]?.id;
  }
  return formData;
};
var StageItemModel = class extends BaseItemModel_default {
  constructor(entity) {
    super(entity);
    this.id = null;
    this.title = null;
    this.toObject = () => {
      return {};
    };
    this.toJSON = () => {
      return {
        ...this.baseToJSON(),
        [CRM_OPPORTUNITY_DETAIL_FIELD_KEY.ID]: this.id,
        [CRM_OPPORTUNITY_DETAIL_FIELD_KEY.NAME]: this.title
      };
    };
    if (entity) {
      this.id = entity[CRM_STAGE_DETAIL_FIELD_KEY.ID] ?? "";
      this.title = entity[CRM_STAGE_DETAIL_FIELD_KEY.TITLE] ?? "";
    }
  }
};

export {
  OpportunityModel,
  OpportunityItemModel,
  StageItemModel
};
/*
 * @copyright   Copyright (C) 2022 AesirX. All rights reserved.
 * @license     GNU General Public License version 3, see LICENSE.
 */
